module.exports = __webpack_public_path__ + "static/media/icon-fashion_men-full-disabled.e7a1bd69.png";